import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { EnglishComponent } from '@english/english.component';
import { MainComponent } from '@english/page/main/main.component';
import { ContentsComponent } from '@english/page/contents/contents.component';
import { BoardComponent } from '@english/page/board/board.component';
import { BoardViewComponent } from '@english/page/board/board-view/board-view.component';

const routes: Routes = [
  { path: '', redirectTo: 'main', pathMatch: 'full' },
  { path: '', component: EnglishComponent,
    children: [
      { path: 'main', component: MainComponent },
      { path: 'contents', component: ContentsComponent },
      { path: 'board', component: BoardComponent,
        children: [
          { path: 'list', component: BoardComponent },
          // { path: 'view', component: BoardViewComponent }
        ] },
      { path: 'board/view', component: BoardViewComponent },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EnglishRoutingModule { }
